import React, { useMemo } from "react";
import { ThemeProvider, useTheme } from "@material-ui/core/styles";
import { createCrmTheme } from "../CrmRelationship/theme";

export default function SchedulesTheme({ children }) {
  const outer = useTheme();
  const theme = useMemo(() => {
    const base = createCrmTheme(outer);
    const foreground = base.palette.type === "dark" ? "#FFFFFF" : base.crm.text;
    return {
      ...base, ticketDark: base.palette.type === "dark",
      palette: { ...base.palette, text: { ...base.palette.text, primary: foreground } },
      overrides: { ...base.overrides,
        MuiIconButton: { root: { ...base.overrides.MuiIconButton.root, color: foreground } },
        MuiSelect: { icon: { color: foreground } }
      }
    };
  }, [outer]);
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
